import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useQueryClient } from 'react-query';
import { mutations } from 'RestAPIs/rapini';

const useUpdateDayLimitArrangement = () => {
  const queryClient = useQueryClient();
  return mutations.useUpdateDayLimitArrangement({
    onSuccess: async () => {
      showSuccessSnackbar();
      await queryClient.invalidateQueries(['dayLimitArrangements', 'list']);
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};

export default useUpdateDayLimitArrangement;
